import React from 'react';
import { useTranslate } from '@federico.moretti/react-translate';
import { useQuery } from 'react-query';

const translationFiles = [`/commons.json`, `/meta.json`, `/sso.json`, `/errors.json`];

async function fetchTranslations(path) {
  try {
    const res = await Promise.all(translationFiles.map((url) => fetch(`${path}${url}`)));
    const translations = await Promise.all(res.map((r) => r.json()));
    return {
      ...translations[0],
      meta: translations[1],
      sso: translations[2],
      errors: translations[3],
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('There was an error loading the translations:', error);
    return {};
  }
}

export function useGetTranslations(path) {
  return useQuery('translations', () => fetchTranslations(path), { enabled: Boolean(path) });
}

export function withTranslate(Component) {
  const WithHook = React.forwardRef((props, ref) => {
    const results = useTranslate(props);
    return <Component {...results} {...props} ref={ref} />;
  });

  WithHook.displayName = `withTranslate(${Component.displayName || Component.name})`;

  return WithHook;
}
